import { toast } from "react-toastify";
import { useHotelContext } from "./useHotelContext";
import { useTranslation } from "react-i18next";


const useHotelSearchParams = () => {
    const { i18n } = useTranslation();
    const { hotelSearchParams , setHotelSearchParams} = useHotelContext();

    const updateHotelSearchParams = (name , value) => {
        setHotelSearchParams((prevState) => {
            if (prevState === null) {
              return { [name]: value };
            }
            return { ...prevState, [name]: value };

        });
    }

    const updateGuests = (roomIdx ,type  ,count  ,op)=>{
        if ( type === "adults" && count < 1){
            toast.error('Adults count must be at least 1')
          return
        }
  
        if ( type === "adults" && count > 9){
            toast.error('Adults count must be at most 9')
          return
        }
  
        if ( type === "children" && count < 0){
            toast.error('Children count cannot be less than 0')
          return
        }
  
        if( type === "children" && count > 4){
            toast.error('Children count must be at most 4')
          return
        }
        
        setHotelSearchParams((prevState)=>{
            const rooms = [...prevState.rooms]
            const room = rooms[roomIdx]
            room[type] = count
            if (type === "children" && op === "add"){
                room.childrenAges.push(3)
            }else if (type === "children" && op === "sub"){
                room.childrenAges.pop()
            }
            return {...prevState , rooms}
        })
    }
    
    const isReadyToSearch = ()=>{
        if (!hotelSearchParams.checkInDate ||
            !hotelSearchParams.checkOutDate ||
            !hotelSearchParams.destination
          ) return false
        return true
    }
    const prepareAvailabilityPayload = () => {
      const payload = {
          room: hotelSearchParams.rooms.length,
          persons: hotelSearchParams.rooms.reduce((acc, room) => {
            return acc + room.adults + room.children;
          }, 0),
          adults: hotelSearchParams.rooms.reduce((acc, room) => {
            return acc + room.adults;
          }, 0),
    
          children: hotelSearchParams.rooms.reduce((acc, room) => {
            return acc + room.children;
          }, 0),
          customer_nationality: "DZ",
          language: i18n.language,
          destination: hotelSearchParams.destination?.description.split("-")[0].trim(),
          destinationCity: hotelSearchParams.destination?.id,
          destinationCityValue: hotelSearchParams.destination?.description,
          checkInDate: hotelSearchParams.checkInDate,
          checkOutDate: hotelSearchParams.checkOutDate,
          nights: Math.floor(
            (new Date(hotelSearchParams.checkOutDate).getTime() -
              new Date(hotelSearchParams.checkInDate).getTime()) /
              (1000 * 60 * 60 * 24)
          ),
        };

        hotelSearchParams.rooms.forEach((room, index) => {
          payload[`adults_${index + 1}`] = room.adults;
          payload[`children_${index + 1}`] = room.children;
    
          room.childrenAges.forEach((age, ageIndex) => {
            payload[`child_age_${index + 1}_${ageIndex + 1}`] = age;
          });
        });

        return payload
  };

    return {
        updateHotelSearchParams,
        isReadyToSearch,
        updateGuests,
        prepareAvailabilityPayload
    };
}

export default useHotelSearchParams;